<template>
  <div class="departList">
    <div class="depart-header">
      <topHeader
        :label="label"
        :textColor="textColor"
        :leftSrc="leftSrc"
        :backgroundColor="backgroundColor"
      ></topHeader>
    </div>
    <div class="depart-select">
      <searchInput @goSearch="goSearch" :placeholder="placeholder"></searchInput>
    </div>
    <div class="depart-list">
      <div
        class="depart-list-label"
        v-for="(dep,depIndex) in newDep"
        :key="depIndex"
        @click="goBilityInfos(dep)"
      >
        <p>{{dep.Name}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import topHeader from "@/components/header.vue";
import searchInput from "@/components/searchInput.vue";
export default {
  data() {
    return {
      label: "政策文件列表",
      backgroundColor: "#ffffff",
      textColor: "#333333",
      leftSrc: require("@/assets/ico@2x.png"),
      departs: [],
      placeholder: "请输入部门名称",
      newDep: []
    };
  },
  components: {
    searchInput,
    topHeader
  },
  mounted() {
    this.initDep();
  },
  methods: {
    initDep() {
      this.$axios({
        url: "api/getDeptList",
        method: "get",
        params: {
          areacode: "00"
        }
      })
        .then(res => {
          this.departs = res.data.deptList; //用于过滤
          this.newDep = res.data.deptList; //用于展示
        })
        .catch(err => {
          console.info(err);
        });
    },
    goSearch(value) {
      this.newDep = this.departs.filter(item => {
        return item.Name.indexOf(value) >= 0;
      });
    },
    goBilityInfos(dep) {
      this.$router.push({
        path: "/bility",
        query: {
          depId: dep.Id,
          deptName: dep.Name
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.departList {
  width: 100%;
  min-height: 100vh;
  background-color: #f6f6f6;
  .depart-header {
    width: 100%;
    height: auto;
  }
  .depart-select {
    width: 100%;
    height: auto;
    padding: 0 1rem;
    margin-top: 1rem;
  }
  .depart-list {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    padding: 0.5rem 0rem;
    .depart-list-label {
      width: 8.85rem;
      height: 1.9rem;
      background-color: #ffffff;
      margin: 0.25rem;
      p {
        width: 100%;
        height: 100%;
        line-height: 1.9rem;
        font-size: 0.8rem;
        text-align: center;
        color: #6b6b6b;
      }
    }
  }
}
</style>